// extracted by mini-css-extract-plugin
export default {"treeMap":"TreeMapDiagram_treeMap__01P0p"};